import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalStorageService } from './local-storage.service';
import { DEFAULT_CONFIG, NgForageOptions, Driver } from 'ngforage';
import { LoggerServiceModule } from '../logger/logger.module';

const localStorageName: string = 'tmhna-portal';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		LoggerServiceModule
	],
	exports: [],
	providers: [
		{
			provide: DEFAULT_CONFIG,
			useValue: {
				name: localStorageName,
				driver: [
					Driver.INDEXED_DB,
					Driver.LOCAL_STORAGE
				]
			} as NgForageOptions
		},
		LocalStorageService
	]
})
export class LocalStorageServiceModule {}
